module.exports = __webpack_public_path__ + "img/pro_5.0ff60e43.png";